/***************************************************************************/
"use client";
/***************************************************************************/

import { cva } from "class-variance-authority";
import {
  AlertTriangleIcon,
  CheckCircleIcon,
  CircleAlertIcon,
  LucideProps,
  SirenIcon,
} from "lucide-react";
import * as React from "react";
import { cn } from "../../../utils/css";
import { ResultContext } from "./result";

const resultIconVariants = cva("", {
  variants: {
    variant: {
      default: "",
      success: "text-success",
      info: "text-info",
      warning: "text-warning",
      error: "text-error",
    },
    size: {
      default: "[&_.lucide]:h-12 [&_.lucide]:w-12",
      sm: "[&_.lucide]:h-7 [&_.lucide]:w-7",
      lg: "[&_.lucide]:h-20 [&_.lucide]:w-20",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

const ResultIcon: React.FC<LucideProps> = ({
  children,
  className,
  ...props
}) => {
  const { variant, size } = React.useContext(ResultContext);

  return (
    <span className={cn(resultIconVariants({ variant, size }), className)}>
      {children ? (
        children
      ) : variant === "success" ? (
        <CheckCircleIcon {...props} />
      ) : variant === "info" ? (
        <CircleAlertIcon {...props} />
      ) : variant === "warning" ? (
        <SirenIcon {...props} />
      ) : variant === "error" ? (
        <AlertTriangleIcon {...props} />
      ) : null}
    </span>
  );
};

const SuccessIcon: React.FC<LucideProps> = ({ className, ...props }) => {
  return (
    <ResultIcon className={className}>
      <CheckCircleIcon {...props} />
    </ResultIcon>
  );
};

const InfoIcon: React.FC<LucideProps> = ({ className, ...props }) => {
  return (
    <ResultIcon className={className}>
      <CircleAlertIcon {...props} />
    </ResultIcon>
  );
};

const WarningIcon: React.FC<LucideProps> = ({ className, ...props }) => {
  return (
    <ResultIcon className={className}>
      <SirenIcon {...props} />
    </ResultIcon>
  );
};

const DangerIcon: React.FC<LucideProps> = ({ className, ...props }) => {
  return (
    <ResultIcon className={className}>
      <AlertTriangleIcon {...props} />
    </ResultIcon>
  );
};

export {
  DangerIcon,
  InfoIcon,
  ResultIcon,
  SuccessIcon,
  WarningIcon,
  resultIconVariants,
};
